import { useQuery } from "@tanstack/react-query";
import { appFetchPublic, isAppApiConfigured } from "@/lib/appApi";

export type PublicPlatformMaintenance = {
  maintenance_mode: boolean;
  maintenance_message: string | null;
};

const KEY = ["platform-maintenance-public"] as const;

/**
 * Public maintenance flags (no JWT). Prefer this in {@link PlatformGuard} instead of
 * `usePlatformSettings` → PostgREST `platform_settings`, which often returns 401 for merchants.
 */
export function usePublicPlatformMaintenance() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<PublicPlatformMaintenance> => {
      if (!isAppApiConfigured()) {
        return { maintenance_mode: false, maintenance_message: null };
      }
      try {
        const j = await appFetchPublic<{
          ok?: boolean;
          maintenance_mode?: boolean;
          maintenance_message?: string | null;
        }>("/api/app/public/platform-maintenance");
        if (!j || typeof j !== "object" || j.ok !== true) {
          return { maintenance_mode: false, maintenance_message: null };
        }
        return {
          maintenance_mode: Boolean(j.maintenance_mode),
          maintenance_message: typeof j.maintenance_message === "string" ? j.maintenance_message : null,
        };
      } catch {
        return { maintenance_mode: false, maintenance_message: null };
      }
    },
    staleTime: 30_000,
    retry: 1,
  });
}
